import CaptableOperations from './container';

export default CaptableOperations;
